module.exports = __webpack_public_path__ + "img/129.1e2af770.jpg";